import React from 'react'
import Navbar from "./Navbar";

export default function CounsellorSuggestion() {
  return (
    <div>
        <Navbar />
        {/* Add your counsellor suggestion component here */}
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Counsellor Home</h2>
        </div>    </div>
  )
}
